import React from 'react';
import clsx from 'clsx';

import styles from './DataNotFound.module.scss';

export type DataNotFoundProps = {
  className?: string;
};

export const DataNotFound: React.FC<DataNotFoundProps> = ({ className, children }) => (
  <div className={clsx(styles.root, className)}>{children}</div>
);
